/** ป้าย QR เครื่องจักร 100×60 มม. แนวนอน (เปลี่ยนขนาดที่ MACHINE_LABEL_SIZE_MM + `.cap-machine-label`/`@page machine-label` ใน desktop.css) */

import { useEffect, useState } from 'react';
import { toString as qrCodeToSvgString } from 'qrcode';

import type { Machine } from '../../lib/machines/types';

export const MACHINE_LABEL_SIZE_MM = { width: 100, height: 60 } as const;

export interface MachineLabelSheetProps {
  readonly machines: readonly Machine[];
  readonly onClose?: () => void;
}

export function MachineLabelSheet({ machines, onClose }: MachineLabelSheetProps) {
  return (
    <div data-testid="machine-label-preview">
      <div className="cap-kanban-tag-controls">
        <button
          type="button"
          className="cap-button cap-button--primary"
          data-testid="machine-label-print-button"
          onClick={() => {
            window.print();
          }}
        >
          พิมพ์ป้าย {machines.length} ใบ ({MACHINE_LABEL_SIZE_MM.width}×{MACHINE_LABEL_SIZE_MM.height} มม.)
        </button>
        {onClose ? (
          <button type="button" className="cap-button cap-button--ghost" onClick={onClose}>
            ปิดตัวอย่าง
          </button>
        ) : null}
      </div>
      <div className="cap-machine-labels">
        {machines.map((machine) => (
          <MachineLabel key={machine.machine_id} machine={machine} />
        ))}
      </div>
    </div>
  );
}

function MachineLabel({ machine }: { readonly machine: Machine }) {
  const [svg, setSvg] = useState<string | null>(null);

  useEffect(() => {
    let active = true;
    setSvg(null);
    void qrCodeToSvgString(machine.qr_payload, { type: 'svg', margin: 0 }).then((out) => {
      if (active) {
        setSvg(out);
      }
    });
    return () => {
      active = false;
    };
  }, [machine.qr_payload]);

  return (
    <div className="cap-machine-label" data-testid="machine-label">
      <div className="cap-machine-label__code" data-testid="machine-label-code">
        {machine.machine_code}
      </div>
      <div className="cap-machine-label__qr" data-testid="machine-label-qr" data-qr-payload={machine.qr_payload}>
        {svg === null ? (
          '—'
        ) : (
          // SVG สร้างโดย `qrcode` จาก qr_payload ที่เซิร์ฟเวอร์ออกให้ — ไม่ใช่ HTML จากผู้ใช้
          <div dangerouslySetInnerHTML={{ __html: svg }} />
        )}
      </div>
      <div className="cap-machine-label__meta">
        <span className="cap-machine-label__name">{machine.name}</span>
        <span>
          Work Center {machine.work_center_code} · โรงงาน {machine.plant_code}
        </span>
      </div>
    </div>
  );
}
